import { ACCOUNT_TYPES } from "../../../../app/appConstants";
import BinIcon from "../../../../components/icon/Icon";
import {
    SelectAccountToggleRowStyled,
    SelectAccountToggleStyled
} from "./styled/LiteTradeSelectAccountStyled";
import { SelectToggleButton } from "../../../../components/SelectToggleButton/SelectToggleButton";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";
import type { IAccountType } from "../../../../app/types/appActions.t";
import { MouseEventHandler } from "react";


interface ILiteTradeSelectAccountToggleProps {
    onClick: MouseEventHandler<HTMLDivElement>,
    showCurrentValue: boolean,
    type: IAccountType,
    value: string,
    disabled?: boolean,
}

const LiteTradeSelectAccountToggle = (props: ILiteTradeSelectAccountToggleProps) => {
    const { disabled, onClick, showCurrentValue, type, value } = props;
    const { getLangPath } = useLangContext();
    return <SelectAccountToggleStyled type={type} onClick={onClick}>
        <SelectToggleButton hideArrow={disabled}>
            {
                type === ACCOUNT_TYPES.DEMO && <span className={'icon'}><BinIcon name={'IcEducation'} /></span>
            }
            <SelectAccountToggleRowStyled>
                <div>{getLangPath(`lite_version.home.${type === ACCOUNT_TYPES.DEMO ? 'account_demo' : 'account_real'}`)}</div>
                {!!showCurrentValue && <div className={'value'}>{value}</div>}
            </SelectAccountToggleRowStyled>
        </SelectToggleButton>
    </SelectAccountToggleStyled>
};


export default LiteTradeSelectAccountToggle;

